import SpiralImages from "./components/SpiralImages";

export default function Home() {
  return (
    <div className="relative h-screen w-full overflow-hidden bg-neutral-50">
      {/* Spiral animated background */}
      <div className="absolute inset-0">
        <SpiralImages
          turns={4}
          speed={1}
          spacing={3}
          spread={10}
          imageSize={209}
          fadeOut={20}
          cornerRadius={20}
        />
      </div>

      {/* Soft vignette to lift foreground text */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/40 via-white/10 to-white/60" />

      {/* Nav */}
      <header className="relative z-10 w-full">
        <nav className="mx-auto flex items-center justify-between px-6 md:px-10 py-6">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-900 text-white font-semibold text-sm">
              ✦
            </span>
            <span className="text-lg font-semibold tracking-tight text-neutral-900">
              Orbit
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8 text-sm text-neutral-700">
            <a
              href="#work"
              className="hover:text-neutral-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Work
            </a>
            <a
              href="#studio"
              className="hover:text-neutral-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Studio
            </a>
            <a
              href="#journal"
              className="hover:text-neutral-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Journal
            </a>
          </div>

          <a
            href="#contact"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-neutral-900 text-white px-4 py-2 text-sm font-medium hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Contact
          </a>

          <button
            aria-label="Open menu"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-neutral-900 text-white cursor-pointer"
          >
            <i className="ri-menu-line text-lg"></i>
          </button>
        </nav>
      </header>

      {/* Centered title */}
      <main className="pointer-events-none relative z-10 flex h-[calc(100vh-96px)] items-center justify-center px-6">
        <h1 className="text-center text-5xl md:text-7xl lg:text-8xl font-semibold tracking-tight text-neutral-900 leading-[1.05]">
          Into the vortex.
        </h1>
      </main>
    </div>
  );
}